import React from 'react';
import { GroupIcon } from '../../appearence/icons/group_icon';
import { preferencesStorageInstance as preferencesStorage } from '../../services/preferencesStorage';
import { POPUP_KEY_ASSIGN_GROUP } from '../../constant';
import { popupOpenService } from '../../shared/popupOpenService';

const PreferencesListItemGroups = ({ preferenceId }) => {
    const openAssignGroupPopup = () => {
        preferencesStorage.cleanSelectedPreferences();
        preferencesStorage.selectPreference(preferenceId, true);
        popupOpenService.callToOpen(POPUP_KEY_ASSIGN_GROUP);
    };

    return (
        <p className="preference__item-count" onClick={openAssignGroupPopup}>
            <GroupIcon />
            {preferencesStorage.getById(preferenceId).groups.length}
        </p>
    );
};

export default PreferencesListItemGroups;
